import { Injectable, Inject } from '@angular/core';
import { Article, ArticleStatus } from './article-models';
import { AutoTablePageableResponse } from '@muchencute/mrrs-types';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { CORE_CONFIG } from '../environment';

@Injectable({
  providedIn: 'root'
})
export class ArticleService {

  private _baseURL: string;

  constructor(private httpClient: HttpClient,
    @Inject(CORE_CONFIG) private coreConfig: any) {
    this._baseURL = `${this.coreConfig.endpoint}api/v1/article`;
  }

  getArticleList(params: { [param: string]: any }): Observable<AutoTablePageableResponse<Article>> {
    return this.httpClient.get<AutoTablePageableResponse<Article>>(`${this._baseURL}s`, {
      params: params,
    });
  }

  getArticle(code: string): Observable<Article> {
    return this.httpClient.get<Article>(`${this._baseURL}/${code}`);
  }

  newArticle(article: Article): Observable<Article> {
    return this.httpClient.post<Article>(`${this._baseURL}`, article);
  }

  updateArticleViews(code: number): Observable<any> {
    return this.httpClient.put(`${this._baseURL}views/${code}`, {});
  }

  updateArticle(article: Article): Observable<Article> {
    return this.httpClient.put<Article>(`${this._baseURL}/${article.code}`, article);
  }

  removeArticle(code: string | string[]): Observable<any> {
    if (!_.isArray(code)) {
      return this.httpClient.delete(`${this._baseURL}/${code}`);
    } else {
      return this.httpClient.delete(`${this._baseURL}`, {
        params: {
          code: code
        }
      });
    }
  }

  updateArticleStatus(code: string | string[], status: ArticleStatus): Observable<any> {
    if (!_.isArray(code)) {
      return this.httpClient.patch(`${this._baseURL}/${code}`, {}, {
        params: {
          status: status
        }
      });
    } else {
      return this.httpClient.patch(`${this._baseURL}`, {}, {
        params: {
          code: code,
          status: status
        }
      });

    }
  }

  recommendArticle(code: string | string[], isRecommended: boolean): Observable<any> {
    if (!_.isArray(code)) {
      return this.httpClient.patch(`${this._baseURL}/${code}`, {}, {
        params: {
          recommend: isRecommended + ''
        },
      });
    } else {
      return this.httpClient.patch(`${this._baseURL}`, {}, {
        params: {
          code: code,
          recommend: isRecommended + ''
        }
      });
    }
  }
}
